import axios from "axios";
import React, {FC, useEffect, useState} from "react";
import { useNavigate } from "react-router-dom";
import TabPanel from 'devextreme-react/tab-panel';
import { handleError } from "../error/ErrorHandler";

const FindId: FC = () => {
  const navigate = useNavigate();
  const [ curItem, setCurItem ] = useState('id');
  const [ usrId, setUsrId ] = useState('');
  const [ usrEml, setUsrEml ] = useState('');
  const [ usrNm, setUsrNm ] = useState('');
  const [ findId, setFindId ] = useState('');
  const [ verificationCode, setVerificationCode ] = useState('');
  const [ isSendMail, setIsSendMail ] = useState(false);

  const tabItem = [
    { key: 'id', value: '아이디 찾기' },
    { key: 'password', value: '비밀번호 찾기' }
  ];

  const findIdByEmail = async () => {
    if(!usrNm?.trim()) return alert('이름을 입력해주세요.');
    if(!usrEml?.trim()) return alert('이메일을 입력해주세요.');
    try {
      const res = await axios.post('/api/user/find/id', { usrEml, usrNm });
      if(!res.data) return alert('해당 아이디가 없습니다.');
      setFindId(res.data);
    } catch(err) {
      handleError(err);
    }
  };

  const clickTitle = (item: any) => {
    setFindId('');
    setUsrId('');
    setUsrEml('');
    setUsrNm('');
    setCurItem(item.key);
  };

  const sendNewPassword = async () => {
    if(!usrId?.trim()) return alert('아이디를 입력해주세요.');
    if(!usrNm?.trim()) return alert('이름을 입력해주세요.');
    if(!usrEml?.trim()) return alert('이메일을 입력해주세요.');
    if(!verificationCode?.trim()) return alert('인증번호를 입력해주세요.');

    try {
      const res = await axios.post('/api/user/find-by-info', { usrId: usrId, usrNm: usrNm, usrEml: usrEml});
      if (!res.data) return alert('가입된 정보가 없습니다.');
    } catch(err) {
      return handleError(err);
    }

    try {
      const res = await axios.post('/api/mail/check/verification-code', { verificationCode });
    } catch(err) {
      return alert('인증에 실패했습니다.');
    }

    try {
      alert('임시 비밀번호를 메일로 전송하였습니다.');
      const res = await axios.post('/api/mail/send/new-password', { usrId, receivers: [ usrEml ]});
    } catch(err) {
      return alert('메일 전송에 실패했습니다.');
    }
  };
  
  const sendEmail = async () => {
    if(!usrEml?.trim()) return alert('이메일을 입력해주세요.');
    try {
      //너무 오래걸려서 일단 전송했다고 알림
      setIsSendMail(true);
      alert('메일로 인증번호를 전송하였습니다.');
      const res = await axios.post('/api/mail/send/verification-code', { receivers: [ usrEml ]});
      if (res.status !== 200) throw new Error();
      } catch(err) {
          alert('메일 전송에 실패했습니다.');
      }
  };

  return (
    <>
      <div className="find-tab">
        <div className={'find-tab-title'}>
          { tabItem.map( (item, idx) => {
            return (
              <div key={idx} className={curItem === item.key ? 'tab-title active' : 'tab-title'} onClick={() => {clickTitle(item)}}>{item.value}</div>
            )
          })}
        </div>
        <div className="find-tab-content">

          <div className="find-tab-content-form">
            { curItem === 'password' && 
              <div>
                <span className={'find-tab-label'}>
                  아이디  
                </span>
                <input id="usrId" value={usrId} type='text' className={'find-tab-input'} onChange={(event) => setUsrId(event.target.value)} />
              </div>
            }
            <div className={'mt-30'}>
              <span className={'find-tab-label'}>
                이름
              </span>
              <input id="usrName" value={usrNm} type='text' className={'find-tab-input'} onChange={(event) => setUsrNm(event.target.value)} />
            </div>
            <div className={'mt-30'}>
              <span className={'find-tab-label '}>
                이메일
              </span>
              <input id="usrEmail" value={usrEml} className={'find-tab-input'} onChange={(event) => setUsrEml(event.target.value)} />
            </div>
            { isSendMail && curItem === 'password' &&
              <div className={'mt-30'}>
                <span className={'find-tab-label '}>
                  인증번호
                </span>
                <input id="verificationCode" value={verificationCode} className={'find-tab-input'} onChange={(event) => setVerificationCode(event.target.value)} />
              </div>
            }
            { curItem === 'id' && 
              <button onClick={findIdByEmail} className={'find-button'}>
                <span>아이디 찾기</span>
              </button>
            }
            { isSendMail && curItem === 'password' &&
              <button onClick={sendNewPassword} className={'find-button'}>
                <span>비밀번호 찾기</span>
              </button>
            }
            { !isSendMail && curItem === 'password' &&
              <button onClick={sendEmail} className={'find-button'}>
                <span>이메일 인증</span>
              </button>
            }
            { findId && 
              <div className="find-id">
                귀하의 ID는 <span className="text-danger">{findId}</span> 입니다.
              </div>
            }
          </div>
        
        </div>
      </div>
    </>
  )
}

export default FindId;
